import React from 'react';

// Inline (not imported .svg files) so they inherit currentColor and recolor
// with whichever button/text color wraps them, instead of being stuck at a
// fixed fill like the existing .svg icon assets.
export function ChartIcon() {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 12V7.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M7 12V2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 12V5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 6.9c0-2.98 2.47-5.4 5.5-5.4s5.5 2.42 5.5 5.4c0 2.98-2.47 5.4-5.5 5.4a5.7 5.7 0 0 1-2.1-.4L2 12.5l.66-2.2A5.24 5.24 0 0 1 1.5 6.9Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
